var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch1717 = function SvgSearch1717(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3177FF",
    fillRule: "evenodd",
    d: "M11.111 4.75a6.361 6.361 0 1 0 0 12.722 6.361 6.361 0 0 0 0-12.722M3.25 11.111a7.861 7.861 0 1 1 15.722 0 7.861 7.861 0 0 1-15.722 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3177FF",
    fillRule: "evenodd",
    d: "M15.604 15.603a.75.75 0 0 1 1.06 0l3.867 3.867a.75.75 0 0 1-1.06 1.06l-3.867-3.866a.75.75 0 0 1 0-1.061",
    clipRule: "evenodd"
  })));
};
export default SvgSearch1717;